'use client';

interface StatItem {
  label: string;
  value: string;
  color?: string;
}

interface StatGridProps {
  items: StatItem[];
  columns?: number;
  isLoading?: boolean;
}

// Two columns on mobile, requested column count from md up. Tailwind classes
// must be statically analyzable, so extend this map if a caller ever needs
// more than 4 columns — unknown values fall back to 4.
const COLUMN_CLASSES: Record<number, string> = {
  2: 'md:grid-cols-2',
  3: 'md:grid-cols-3',
  4: 'md:grid-cols-4',
};

export function StatGrid({ items, columns = 4, isLoading }: StatGridProps) {
  const gridClass = `grid grid-cols-2 ${COLUMN_CLASSES[columns] ?? 'md:grid-cols-4'} gap-px bg-[#1F2937]`;

  if (isLoading) {
    return (
      <div className={gridClass}>
        {Array.from({ length: columns * 2 }).map((_, i) => (
          <div key={i} className="bg-[#111827] p-3">
            <div className="h-2 w-16 mb-2 bg-[#1F2937] animate-pulse rounded" />
            <div className="h-4 w-20 bg-[#1F2937] animate-pulse rounded" />
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className={gridClass}>
      {items.map((item, i) => (
        <div key={i} className="bg-[#111827] p-3">
          <div className="text-[10px] text-[#6B7280] uppercase tracking-wider mb-1">
            {item.label}
          </div>
          <div className={`font-mono text-sm font-medium tabular-nums ${item.color || 'text-[#E5E7EB]'}`}>
            {item.value}
          </div>
        </div>
      ))}
    </div>
  );
}
